export default {"src":"/_next/static/image/public/images/ic_process_pending.56bda28abd21525d0e2c284ef02d7bd4.svg","height":53,"width":56};